import uuid from 'uuid';

import utils from '@utils/index.js';

import itemMap from '../api/transform/item-map';

const filterStatuses = () => {
    const statuses = itemMap.status;
    return Object.keys(statuses).map((key) => {
        return {
            text: statuses[key].label,
            value: key,
        };
    });
};

export default {
    companyName: 'Pacific Screening, Inc',
    // Set a selected NavItemId to exclusively include that navItem
    // selectedNavItemId: 'screening-public-records',

    categories: [
        {
            id: 'processing',
            title: 'Processing',
            icon: 'mdi-table-account',
        },
        {
            id: 'applicant',
            title: 'Applicant',
            icon: 'mdi-account',
        },
        {
            id: 'application',
            title: 'Application',
            icon: 'mdi-account-box-multiple',
        },
        {
            id: 'summary',
            title: 'Summary',
            icon: 'mdi-sigma',
        },
        {
            id: 'notes',
            title: 'Notes',
            icon: 'mdi-clipboard-text-multiple',
        },
        {
            id: 'contacts',
            title: 'Contacts',
            icon: 'mdi-contacts',
        },

        {
            id: 'tasks',
            title: 'Tasks',
            icon: 'mdi-format-list-checks',
        },
        {
            id: 'activities',
            title: 'Activities',
            icon: 'mdi-timeline',
        },
        {
            id: 'invoice',
            title: 'Invoice',
            icon: 'mdi-currency-usd',
        },
    ],
    /**
     * navItems define the Screen Processing Quicklinks and Tiles
     */
    navItems: [
        // {
        //     id: 'screening-scorecard',
        //     visible: true,
        //     title: 'Scorecard',
        //     headingColor: 'accent darken-1',
        //     icon: 'mdi-clipboard-list-outline',
        //     class: 'error--text text--lighten-2',
        //     component: 'screening-scorecard',
        //     params: {
        //         scorecard: 'screen.scorecard',
        //     },
        //     source: 'currentScreen',
        //     maxHeight: 590,
        //     layout: 'main',
        //     roles: [
        //         'Super Admin',
        //         'PSI Admin',
        //         'PSI Staff',
        //         'Program Admin',
        //         'Instructor',
        //         'Company Admin',
        //         'Company HR',
        //         'Company Supervisor',
        //         'Leasing Agent/User',
        //         'Student',
        //         'Tenant',
        //     ],
        //     order: 10,
        //     category: 'processing',
        //     colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        // },
        {
            id: 'screening-rental-history',
            title: 'Rental History',
            visible: true,
            headingColor: 'primary darken-1',
            icon: 'mdi-home-map-marker',
            class: 'info--text text--darken-1',
            layout: 'main',
            maxHeight: 600,
            params: {
                addresses: 'applicant.addresses',
                order_id: 'order_id',
            },
            source: 'currentScreen',
            component: 'screening-rental-history',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
            ],
            order: 20,
            category: 'processing',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-employment-history',
            title: 'Employment',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-briefcase-account',
            class: 'alternate1--text text--darken-2',
            layout: 'main',
            maxHeight: 300,
            params: {
                employers: 'applicant.employers',
                order_id: 'order_id',
            },
            source: 'currentScreen',
            component: 'screening-employment-history',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
            ],
            order: 30,
            category: 'processing',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-public-records',
            title: 'Public Records',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-scale-balance',
            class: 'alternate5--text text--lighten-2',
            layout: 'main',
            params: {
                summary: 'screen.summary.summary',
                crimes: 'screen.search.crimes',
                evictions: 'screen.search.evictions',
            },
            source: 'currentScreen',
            maxHeight: 600,
            component: 'screening-process-public-records',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Program Admin',
                'Instructor',
                'Student',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
            ],
            order: 40,
            category: 'processing',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-credit',
            title: 'Credit',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-file-chart',
            class: 'warning--text text--darken-3',
            layout: 'main',
            params: {
                search: 'screen.search.result',
                summary: 'screen.summary.summary',
                reports: 'screen.reports',
            },
            source: 'currentScreen',
            maxHeight: 600,
            component: 'screening-process-credit',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Program Admin',
                'Instructor',
                'Student',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
            ],
            order: 50,
            category: 'processing',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-household',
            visible: false,
            title: 'Household',
            headingColor: 'accent darken-1',
            icon: 'mdi-clipboard-text-multiple',
            class: 'alternate3--text text--darken-2',
            component: 'screening-household',
            params: {
                summary: 'household_summary',
                rent: 'applicant.application.rent',
            },
            source: 'currentScreen',
            maxHeight: 300,
            layout: 'main',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Tenant',
            ],
            order: 60,
            category: 'other',
            colsClass: 'col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12',
        },
        {
            id: 'screening-applicant',
            title: 'Applicant',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-clipboard-account',
            class: 'alternate1--text text--darken-2',
            params: {
                applicant: 'applicant',
            },
            source: 'currentScreen',
            layout: 'main',
            maxHeight: 380,
            component: 'screening-process-applicant',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
                'Tenant',
                'Student',
            ],
            order: 70,
            category: 'applicant',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-application',
            title: 'Application',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-account-box-multiple',
            class: 'alternate1--text text--darken-2',
            params: {
                application_id: 'applicant.application.id',
            },
            source: 'currentScreen',
            layout: 'main',
            maxHeight: 380,
            component: 'screening-application',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
                'Tenant',
                'Student',
            ],
            order: 80,
            category: 'application',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-summary',
            title: 'Summary',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-clipboard-text',
            class: 'alternate4--text text--darken-2',
            component: 'screening-summary',
            params: {
                summary: 'screen.summary.summary',
            },
            source: 'currentScreen',
            maxHeight: 391,
            layout: 'main',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
                'Tenant',
            ],
            order: 90,
            category: 'summary',
            colsClass: 'col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12',
        },
        {
            id: 'screening-flags',
            title: 'Flags',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-flag-variant',
            class: 'warning--text text--darken-1',
            component: 'screening-flags',
            params: {
                flags: 'flags',
            },
            source: 'currentScreen',
            maxHeight: 198,
            layout: 'main',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
                'Tenant',
            ],
            order: 100,
            category: 'summary',
            colsClass: 'col-lg-6 col-xl-6 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-details',
            title: 'Details',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-card-account-details',
            class: 'secondary--text text--darken-2',
            component: 'screening-details',
            params: {
                items: 'details.items',
                products: 'products',
                applicant: 'applicant',
                property: 'property',
                screen: 'screen',
            },
            maxHeight: 300,
            source: 'currentScreen',
            layout: 'main',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
                'Tenant',
            ],
            order: 110,
            category: 'summary',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },

        {
            id: 'screening-notes',
            title: 'Notes',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-note-multiple',
            class: 'error--text text--darken-1',
            layout: 'main',
            component: 'screening-notes-listing',
            params: {
                notes: 'screen.all_notes',
            },
            source: 'currentScreen',
            maxHeight: 600,
            height: 800,
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
            ],
            order: 120,
            category: 'notes',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-contacts',
            title: 'Contacts',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-contacts',
            class: 'secondary--text text--lighten-2',
            component: 'screening-contacts',
            params: {
                contacts: 'contacts',
            },
            source: 'currentScreen',
            maxHeight: 600,
            layout: 'main',
            order: 130,
            category: 'contacts',
            roles: ['Super Admin', 'PSI Admin', 'PSI Staff'],
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-tasks',
            title: 'Tasks',
            visible: true,
            headingColor: 'accent darken-1 darken-2',
            icon: 'mdi-format-list-checks',
            class: 'alternate2--text text--lighten-2',
            component: 'screening-tasks',
            params: {
                progress: 'screen.progress',
                tasks: 'screen.tasks',
            },
            source: 'currentScreen',
            height: 1000,
            maxHeight: 1200,
            layout: 'main',
            roles: ['Super Admin', 'PSI Admin', 'PSI Staff'],
            order: 140,
            category: 'tasks',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-activities',
            component: 'screening-activities',
            visible: true,
            params: {
                items: 'activities',
            },
            source: 'currentScreen',
            title: 'Activities',
            headingColor: 'accent darken-1',
            icon: 'mdi-timeline',
            class: 'alternate4--text text--darken-2',
            layout: 'main',
            height: 1200,
            maxHeight: 1200,
            order: 150,
            category: 'activities',
            roles: ['Super Admin', 'PSI Admin', 'PSI Staff'],
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },

        {
            id: 'screening-notifications',
            title: 'Notifications',
            visible: false,
            headingColor: 'accent darken-1',
            icon: 'mdi-bell',
            class: 'warning--text text--darken-2',
            component: 'screening-notifications',
            params: {
                notifications: 'screen.notifications',
            },
            source: 'currentScreen',
            layout: 'main',
            maxHeight: 600,
            roles: ['Super Admin', 'PSI Admin', 'PSI Staff'],
            colsClass: 'col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12',
        },

        {
            id: 'screening-messages',
            title: 'Messages',
            visible: false,
            headingColor: 'accent darken-1',
            icon: 'mdi-comment-text-multiple',
            class: 'alternate2--text text--darken-2',
            component: 'screening-blank',
            source: 'currentScreen',
            layout: 'main',
            maxHeight: 600,
            category: 'messages',
            roles: ['Super Admin', 'PSI Admin', 'PSI Staff'],
            colsClass: 'col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12',
        },

        {
            id: 'screening-files',
            title: 'Files',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-file-document-multiple',
            class: 'alternate3--text text--lighten-2',
            layout: 'main',
            maxHeight: 600,
            component: 'screening-blank',
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
            ],
            order: 135,
            category: 'files',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
        {
            id: 'screening-invoice',
            title: 'Invoice',
            visible: true,
            headingColor: 'accent darken-1',
            icon: 'mdi-currency-usd',
            component: 'screening-invoice',
            class: 'alternate5--text text--lighten-2',
            params: {
                invoices: 'invoices',
                invoice_amount: 'invoice_amount',
                due_amount: 'due_amount',
                paid_amount: 'paid_amount',
                property: 'property',
                payment: 'payment',
            },
            roles: [
                'Super Admin',
                'PSI Admin',
                'PSI Staff',
                'Company Admin',
                'Company HR',
                'Company Supervisor',
                'Leasing Agent/User',
            ],
            source: 'currentScreen',
            layout: 'main',
            maxHeight: 300,
            order: 160,
            category: 'invoice',
            colsClass: 'col-lg-12 col-xl-12 col-md-12 col-sm-12 col-12',
        },
    ],
    processLayouts: {
        instant: [
            {
                id: 'screening-applicant',
                layout: 'main',
            },
            {
                id: 'screening-application',
                layout: 'main',
            },
            {
                id: 'screening-summary',
                layout: 'main',
            },
            {
                id: 'screening-public-records',
                layout: 'main',
            },
            {
                id: 'screening-credit',
                layout: 'main',
            },
            {
                id: 'screening-invoice',
                layout: 'main',
            },
            {
                id: 'screening-details',
                layout: 'main',
            },
            {
                id: 'screening-flags',
                layout: 'main',
            },
            {
                id: 'screening-tasks',
                layout: 'main',
            },
            {
                id: 'screening-activities',
                layout: 'main',
            },
        ],
        student: [
            {
                id: 'screening-applicant',
                layout: 'sidebar',
            },
            {
                id: 'screening-summary',
                layout: 'main',
            },
            {
                id: 'screening-public-records',
                layout: 'main',
            },
            {
                id: 'screening-credit',
                layout: 'main',
            },
            {
                id: 'screening-invoice',
                layout: 'main',
            },
            {
                id: 'screening-tasks',
                layout: 'sidebar',
            },
            {
                id: 'screening-activities',
                layout: 'sidebar',
            },
            {
                id: 'screening-notifications',
                layout: 'sidebar',
            },
        ],
        full: [
            {
                id: 'screening-applicant',
                layout: 'main',
            },
            {
                id: 'screening-application',
                layout: 'main',
            },
            {
                id: 'screening-summary',
                layout: 'main',
            },
            {
                id: 'screening-notes',
                layout: 'main',
            },
            {
                id: 'screening-rental-history',
                layout: 'main',
            },
            {
                id: 'screening-employment-history',
                layout: 'main',
            },
            {
                id: 'screening-public-records',
                layout: 'main',
            },
            {
                id: 'screening-credit',
                layout: 'main',
            },
            {
                id: 'screening-invoice',
                layout: 'main',
            },
            {
                id: 'screening-details',
                layout: 'main',
            },
            {
                id: 'screening-flags',
                layout: 'main',
            },
            {
                id: 'screening-tasks',
                layout: 'main',
            },
            {
                id: 'screening-activities',
                layout: 'main',
            },
            {
                id: 'screening-notifications',
                layout: 'sidebar',
            },
            {
                id: 'screening-contacts',
                layout: 'main',
            },
            {
                id: 'screening-messages',
                layout: 'main',
            },
        ],
    },

    processToolBarItems: [
        {
            type: 'button',
            icon: 'mdi-cellphone',
            tooltip: 'Call',
            event: 'screening-toolbar-call',
        },
        {
            type: 'button',
            icon: 'mdi-message',
            tooltip: 'Messages',
            event: 'screening-toolbar-messages',
        },
        {
            type: 'button',
            icon: 'mdi-note-plus',
            tooltip: 'Add Note',
            event: 'screening-toolbar-add-note',
        },
        {
            type: 'divider',
        },
        {
            type: 'button',
            icon: 'mdi-share-variant',
            tooltip: 'Share',
            event: 'screening-toolbar-share',
        },
        {
            type: 'button',
            icon: 'mdi-file-pdf-box',
            tooltip: 'Print',
            event: 'screening-toolbar-print',
        },
        {
            type: 'button',
            icon: 'mdi-help-circle',
            tooltip: 'Guide',
            event: 'screening-toolbar-view-guide',
        },
        {
            type: 'divider',
        },
    ],
    activities: {
        Screen: { color: '#57748f', icon: 'mdi-clipboard-account' },
        Product: { color: '#515e85', icon: 'mdi-tag' },
        File: { color: '#4f6f78', icon: 'mdi-file' },
        Note: { color: '#578f8c', icon: 'mdi-pencil-box' },
        Action: { color: '#518573', icon: 'mdi-flash' },
        Report: { color: 'secondary', icon: 'mdi-chart-bar' },
        Search: { color: '#062931', icon: 'mdi-magnify' },
        Notification: { color: '#25445d', icon: 'mdi-bell' },
        'Invoice Item': { color: '#00192f', icon: 'mdi-cash-usd' },
    },
    contacts: {
        Applicant: {
            color: 'alternate3',
        },
        Landlord: {
            color: 'alternate1',
        },
        Employer: {
            color: 'alternate2',
        },
        Property: {
            color: 'alternate4',
        },
        Other: {
            color: 'alternate5',
        },
    },
    filters: [
        {
            icon: 'mdi-account',
            name: 'assigned_to',
            label: 'Assigned To',
            default: '',
            value: '',
            itemText: 'name',
            itemValue: 'id',
            items: [],
        },
        {
            icon: 'mdi-clipboard-check',
            name: 'status',
            label: 'Status',
            default: '',
            value: '',
            itemText: 'text',
            itemValue: 'value',
            items: filterStatuses(),
        },

        {
            icon: 'mdi-domain',
            name: 'company',
            label: 'Company',
            default: '',
            value: '',
            itemText: 'name',
            itemValue: 'id',
            items: [],
        },
        {
            icon: 'mdi-home-city',
            name: 'property',
            label: 'Property',
            default: '',
            value: '',
            itemText: 'name',
            itemValue: 'id',
            items: [],
        },

        {
            icon: 'mdi-calendar-range',
            name: 'date_range',
            label: 'Date Range',
            default: 'Last 60 days',
            value: 'Last 60 days',
            itemText: 'range',
            itemValue: 'range',
            items: [
                {
                    range: 'Last 4 hours (new)',
                },
                {
                    range: 'Last 7 days',
                },
                {
                    range: 'Last 14 days',
                },
                {
                    range: 'Last 30 days',
                },
                {
                    range: 'Last 60 days',
                },
                {
                    range: 'Last 90 days',
                },
                {
                    range: 'This Month',
                },
                {
                    range: 'Last Month',
                },
                {
                    range: 'This Quarter',
                },
                {
                    range: 'Last Quarter',
                },
                {
                    range: 'This Year',
                },
                {
                    range: 'Last Year',
                },
            ],
        },
        {
            icon: 'mdi-clock-alert',
            name: 'time_pending',
            label: 'Time Pending',
            default: '',
            value: '',
            itemText: 'pending',
            itemValue: 'pending',
            items: [
                {
                    pending: '< 8 hours',
                },
                {
                    pending: '8-24 hours',
                },
                {
                    pending: '24-48 hours',
                },
                {
                    pending: '> 48 hours',
                },
            ],
        },
    ],
    quicklinks: [
        {
            icon: 'mdi-account',
            title: 'My Orders',
            class: 'warning--text text--darken-2',
        },
        {
            icon: 'mdi-timer-sand',
            title: 'Pending Orders',
            class: 'accent--text text--darken-1',
        },
        {
            icon: 'mdi-clock-alert',
            title: 'Overdue Orders',
            class: 'error--text text--darken-2',
        },
        {
            icon: 'mdi-clipboard-alert',
            title: 'New Orders',
            class: 'alternate3--text text--darken-2',
        },
    ],
    actions: [
        {
            icon: 'mdi-clipboard-text-multiple',
            title: 'Group Applicants',
            slug: 'group-applicants',
        },
        {
            divider: true,
        },
        {
            icon: 'mdi-clipboard-remove',
            title: 'Delete Orders',
            slug: 'delete-orders',
            class: 'error--text text--darken-2',
        },
    ],
    evictionActions: [
        {
            icon: 'mdi-clipboard-remove',
            title: 'Delete Evictions',
            slug: 'delete-evictions',
            class: 'error--text text--darken-2',
        },
    ],
    evictionQuicklinks: [
        {
            icon: 'mdi-equal',
            title: 'Matched',
            class: 'warning--text text--darken-2',
        },
        {
            icon: 'mdi-not-equal',
            title: 'Unmatched',
            class: 'accent--text text--darken-1',
        },
        {
            icon: 'mdi-alpha-o-circle',
            title: 'OJIN Records',
            class: 'error--text text--darken-2',
        },
        {
            icon: 'mdi-alpha-c-circle',
            title: 'CIC Records',
            class: 'alternate3--text text--darken-2',
        },
    ],
    evictionFilters: [
        {
            icon: 'mdi-map-marker-alert',
            name: 'matched',
            label: 'Address Match',
            default: '',
            value: '',
            itemText: 'text',
            itemValue: 'text',
            items: [
                {
                    text: 'Matched',
                },
                {
                    text: 'Partial Match',
                },
                {
                    text: 'No Match',
                },
            ],
        },
        {
            icon: 'mdi-import',
            name: 'source',
            label: 'Source',
            default: '',
            value: '',
            itemText: 'text',
            itemValue: 'text',
            items: [
                {
                    text: 'OJIN',
                },
                {
                    text: 'CIC',
                },
            ],
        },
    ],
    newApplicationOptions: [
        {
            name: 'upload',
            order: 1,
            type: 'tenant',
            title: 'Upload Application',
            logo:
                'https://pacific-screening.imgix.net/apm-fb-logo.png?auto=enhance,compress,format&width=60&q=60',
            action: 'Upload Application',
            icon: 'mdi-file-upload',
            alert:
                'Upload an application from multiple sources including AppFolio.',
            href: utils.buildUrl('uploads', 'uploads/start'),
            disabled: false,
        },
        {
            name: 'invite',
            type: 'tenant',
            order: 2,
            title: 'Invite Applicants',
            action: 'Invite Applicants',
            color: 'accent',
            icon: 'mdi-email-send',
            alert:
                'Create an online application invitation for multiple applicants.',
            to: { name: 'Application Invite' },
            disabled: false,
        },
        {
            name: 'create',
            type: 'tenant',
            order: 3,
            title: 'Create Application',
            action: 'Create Application',
            color: 'alternate4',
            icon: 'mdi-clipboard-account',
            alert: 'Create an application using the application entry forms.',
            to: { name: 'Application Create' },
            disabled: false,
        },
        {
            name: 'import',
            type: 'tenant',
            order: 4,
            title: 'Rent Manager',
            action: 'Import Application',
            logo:
                'https://pacific-screening.imgix.net/rm-logo-sm.png?auto=enhance,compress,format&width=60&q=60',
            icon: 'mdi-application-import',
            alert:
                'Import applications entered in Rent Manager. Applies to limited companies.',
            to: { name: 'Application Import' },
            disabled: false,
        },
        {
            name: 'upload',
            order: 1,
            type: 'employment',
            title: 'Upload Application',
            color: 'accent',
            action: 'Upload Application',
            icon: 'mdi-file-upload',
            alert: 'Upload an employment screening application.',
            to: { name: 'Upload Employment Application' },
            disabled: true,
        },
        {
            name: 'create',
            type: 'employment',
            order: 3,
            title: 'Create Application',
            action: 'Create Application',
            color: 'alternate4',
            icon: 'mdi-clipboard-account',
            alert: 'Create an application using the application entry forms.',
            to: { name: 'Application Create' },
            disabled: false,
        },
    ],
    summaryFilters: [
        {
            icon: 'mdi-radiobox-marked',
            name: 'type',
            label: 'Summary Type',
            default: '',
            value: '',
            itemText: 'type',
            itemValue: 'type',
            items: [
                {
                    type: 'Addresses',
                },
                {
                    type: 'Names',
                },
                {
                    type: 'Birthdates',
                },
            ],
        },
    ],

    notesFilters: [
        {
            icon: 'mdi-radiobox-marked',
            name: 'type',
            label: 'Note Type',
            default: '',
            value: '',
            itemText: 'type',
            itemValue: 'type',
            items: [
                {
                    type: 'Screen',
                },
                {
                    type: 'Applicant Address',
                },
                {
                    type: 'Applicant Employer',
                },
                {
                    type: 'Screen Reference',
                },
            ],
        },
    ],
    rentalAddressToolBarItems: [
        {
            name: 'add_note',
            icon: 'mdi-note-plus',
            tooltip: 'Add Note',
            disabled: false,
        },
        {
            name: 'landlord_lookup',
            icon: 'mdi-home-search',
            tooltip: 'Landlord Lookup',
            disabled: false,
        },
        {
            name: 'create_reference',
            icon: 'mdi-card-account-details-star-outline',
            tooltip: 'Create Rental Reference',
            disabled: false,
        },
        {
            name: 'upload_reference',
            icon: 'mdi-file-upload',
            tooltip: 'Upload Rental Reference',
            disabled: false,
        },
        {
            name: 'stop_sending',
            icon: 'mdi-send-lock',
            tooltip: 'Stop Send Outs',
            disabled: false,
        },
        {
            name: 'remove_address',
            icon: 'mdi-delete',
            tooltip: 'Delete Address',
            disabled: false,
        },
    ],
    employmentEmployerToolBarItems: [
        {
            name: 'add_note',
            icon: 'mdi-note-plus',
            tooltip: 'Add Note',
            disabled: false,
        },
        {
            name: 'employer_lookup',
            icon: 'mdi-briefcase-search',
            tooltip: 'Employer Lookup',
            disabled: false,
        },
        {
            name: 'create_reference',
            icon: 'mdi-card-account-details-star-outline',
            tooltip: 'Create Employer Reference',
            disabled: false,
        },
        {
            name: 'upload_reference',
            icon: 'mdi-file-upload',
            tooltip: 'Upload Employer Reference',
            disabled: false,
        },
        {
            name: 'stop_sending',
            icon: 'mdi-send-lock',
            tooltip: 'Stop Send Outs',
            disabled: false,
        },
        {
            name: 'remove_employer',
            icon: 'mdi-delete',
            tooltip: 'Delete Employer',
            disabled: false,
        },
    ],
    rentalAddressMenuOptions: [
        {
            id: uuid.v4(),
            title: 'Activity',
            icon: 'mdi-timeline-check',
            params: {
                activity: 'activity',
            },
            component: 'rental-employment-activity',
        },
        {
            id: uuid.v4(),
            title: 'Contacts',
            icon: 'mdi-account-multiple',
            params: {
                contacts: 'contacts',
            },
            component: 'rental-employment-contacts',
        },
        {
            id: uuid.v4(),
            title: 'Notes',
            icon: 'mdi-note-multiple',
            params: {
                notes: 'notes',
            },
            component: 'rental-employment-notes',
        },
        {
            id: uuid.v4(),
            title: 'Messages',
            icon: 'mdi-forum',
            params: { messages: 'messages' },
            component: 'rental-employment-messages',
        },
        {
            id: uuid.v4(),
            title: 'Reference',
            icon: 'mdi-card-account-details-star-outline',
            params: {
                references: 'references',
            },
            component: 'reference-widget',
        },
    ],
    employmentEmployerMenuOptions: [
        {
            id: uuid.v4(),
            title: 'Activity',
            icon: 'mdi-timeline-check',
            params: {
                activity: 'activity',
            },
            component: 'rental-employment-activity',
        },
        {
            id: uuid.v4(),
            title: 'Contacts',
            icon: 'mdi-account-multiple',
            params: {
                contacts: 'contacts',
            },
            component: 'rental-employment-contacts',
        },
        {
            id: uuid.v4(),
            title: 'Notes',
            icon: 'mdi-note-multiple',
            params: {
                notes: 'notes',
            },
            component: 'rental-employment-notes',
        },
        {
            id: uuid.v4(),
            title: 'Messages',
            icon: 'mdi-forum',
            params: { messages: 'messages' },
            component: 'rental-employment-messages',
        },
        {
            id: uuid.v4(),
            title: 'Reference',
            icon: 'mdi-card-account-details-star-outline',
            params: {
                references: 'references',
            },
            component: 'reference-widget',
        },
    ],
    contactActionsMenuOptions: [
        { title: 'Unlink', icon: 'mdi-link-variant-off' },
        { title: 'Edit', icon: 'mdi-account-edit' },
        { title: 'Delete', icon: 'mdi-account-remove' },
        { title: 'Make Primary', icon: 'mdi-account-check' },
        { title: 'Rate Contact', icon: 'mdi-account-star' },
    ],
    rentalReferenceTransform: [
        {
            key: 'name',
        },
        {
            key: 'completed_at',
        },
        {
            key: 'rent.stated',
            format: 'currency',
        },
        {
            key: 'rent.actual',
            format: 'currency',
        },
        {
            key: 'move_in.stated',
        },
        {
            key: 'move_in.actual',
        },
        {
            key: 'move_out.stated',
        },
        {
            key: 'move_out.actual',
        },
        {
            key: 'lease_type',
            format: 'uppercase',
        },
        {
            heading: 'Disclosures',
        },
        {
            key: 'complaints.incurred',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'covid_deferred_rent.incurred',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'nsf_checks.incurred',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'past_due_rent.incurred',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'damages.incurred',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'three_day_notices.incurred',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'late_payments.incurred',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'unauthorized_occupants',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'unauthorized_pets',
            type: 'chip',
            format: 'boolean',
        },
        {
            key: 'rent_again',
            type: 'chip',
            format: 'boolean',
            question_format: 'Positive Good',
        },
        {
            key: 'rental_agreement',
            type: 'chip',
            format: 'boolean',
            question_format: 'Positive Good',
        },
        {
            key: 'proper_notice',
            type: 'chip',
            format: 'boolean',
            question_format: 'Positive Good',
        },
        {
            key: 'vacate_evicted',
            type: 'chip',
            format: 'boolean',
        },

        {
            key: 'proper_notice',
            type: 'chip',
            format: 'boolean',
            question_format: 'Positive Good',
        },
        {
            key: 'good_renter',
            type: 'chip',
            format: 'boolean',
            question_format: 'Positive Good',
        },
    ],
    employerReferenceTransform: [
        {
            key: 'name',
        },
        {
            key: 'completed_at',
        },
        {
            key: 'monthly_income.stated',
            format: 'currency',
        },
        {
            key: 'monthly_income.actual',
            format: 'currency',
        },
        {
            key: 'start_date.actual',
        },
        {
            key: 'start_date.stated',
        },
        {
            key: 'end_date.actual',
        },
        {
            key: 'end_date.stated',
        },
        {
            key: 'would_rehire',
            type: 'chip',
            format: 'boolean',
            question_format: 'Positive Good',
        },
        {
            heading: 'Comments',
        },
        {
            key: 'attendance',
        },
        {
            key: 'comments',
        },
        {
            key: 'completed_assignments',
        },
        {
            key: 'disciplinary_action',
        },
        {
            key: 'job_duties',
        },
        {
            key: 'performance',
        },
        {
            key: 'response_to_criticism',
        },
    ],
    pagination: {
        perPage: 50,
        perPageOptions: [10, 25, 50, 100, 200],
    },

    printLayouts: {
        testing: {
            pages: [
                ['Profile', 'Scorecard'],
                ['Credit'],
                ['Crime-Disclaimer', 'Crime-Summary', 'Crime', 'Evictions'],
            ],
        },
        default: {
            pages: [
                ['Profile', 'Recommendation', 'Ratings'],
                ['Scorecard', 'Credit'],
                [
                    'Debt',
                    'Incomes',
                    'Rental-History',
                    'Crime-Disclaimer',
                    'Crime-Summary',
                ],
                ['Crime', 'Evictions'],
            ],
        },
        student: {
            pages: [
                ['Profile'],
                ['Credit', 'Debt', 'Crime-Disclaimer', 'Crime-Summary'],
                ['Crime', 'Evictions'],
            ],
        },
        instant: {
            pages: [
                ['Profile', 'Scorecard'],
                ['Credit', 'Debt', 'Crime-Disclaimer', 'Crime-Summary'],
                ['Crime', 'Evictions'],
            ],
        },
        extended: {
            pages: [
                ['Profile', 'Recommendation', 'Rating'],
                ['Scorecard', 'Credit'],
                [
                    'Debt',
                    'Incomes',
                    'Rental-History',
                    'Crime-Disclaimer',
                    'Crime-Summary',
                ],
                ['Crime', 'Evictions', 'CreditDetails'],
            ],
        },
    },
    printSections: {
        CreditDetails: {
            component: 'credit-details',
            params: {
                search: 'currentScreen.screen.search',
            },
        },
        Profile: {
            component: 'applicant-profile',
            params: {
                applicant: 'currentScreen.applicant',
                created_at: 'currentScreen.created_at',
                property: 'currentScreen.property',
                products: 'currentScreen.products',
                assigned_to: 'currentScreen.screen.assigned_to',
            },
        },
        Recommendation: {
            component: 'screen-recommendation',
            params: {
                screen: 'currentScreen.screen',
            },
        },
        Ratings: {
            component: 'screening-ratings',
            params: {
                scorecard: 'currentScreen.screen.scorecard',
            },
        },
        Scorecard: {
            component: 'screening-scorecard',
            params: {
                scorecard: 'currentScreen.screen.scorecard',
            },
        },
        Credit: {
            component: 'applicant-credit',
            params: {
                search: 'currentScreen.screen.search',
            },
        },
        Debt: {
            component: 'applicant-debt',
            params: {
                search: 'currentScreen.screen.search',
            },
        },
        Incomes: {
            component: 'household-incomes',
            params: {
                currentApplication: 'currentApplication',
            },
        },
        'Rental-History': {
            component: 'rental-history',
            params: {
                addresses: 'currentScreen.applicant.addresses',
            },
        },
        'Crime-Disclaimer': {
            component: 'crime-disclaimer',
            params: [],
        },
        'Crime-Summary': {
            component: 'crime-summary',
            params: {
                crimes: 'currentScreen.screen.search.crimes',
            },
        },
        Crime: {
            component: 'applicant-crime',
            params: {
                crimes: 'currentScreen.screen.search.crimes',
            },
        },
        Evictions: {
            component: 'applicant-evictions',
            params: {
                evictions: 'currentScreen.screen.search.evictions',
            },
        },
    },
};
